import { Injectable } from '@angular/core'; 
import { BehaviorSubject } from 'rxjs'; 

@Injectable() export class DataStorage {
    private dataStorage = new BehaviorSubject(''); 
    dataStorageMessage = this.dataStorage.asObservable();
    setData(data) { 
      this.dataStorage.next(data); 
    }
}